<template>
  <div>
    <StringArray class="mb-2" object-name="election" :attribute-name="attribute"
      :items="items.filter((item: string) => item !== '*')" title="http, https" item-type="url" item-pattern="^https?://.*"
      :placeholder="placeholder" :disabled="allowAllDomains" v-show="!allowAllDomains" />
    <div class="alert alert-warning" v-if="allowAllDomains">
      <div class="d-flex align-items-center">
        <AVIcon icon="exclamation-triangle" class="h4 mb-0 me-3" />
        <div>
          <span v-text="$t('js.backend.election_config.override.access__allowed_domains.allow_all_warning')"></span>
          <a class="alert-link" href="https://owasp.org/www-community/attacks/Clickjacking" target="_blank"
            v-text="$t('js.backend.election_config.override.access__allowed_domains.link_to_ui_redress_resource')"></a>
        </div>
      </div>
    </div>
    <div class="custom-control custom-switch">
      <input :id="`election_${attribute}`" class="custom-control-input" :name="`election[${attribute}][]`"
        type="checkbox" v-model="allowAllDomains" value="*">
      <label class="custom-control-label" :for="`election_${attribute}`">
        <span v-text="$t('js.backend.election_config.override.access__allowed_domains.allow_all_domains')"></span>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import StringArray from "../attributes/StringArray.vue";

export default defineComponent({
  name: "AllowedDomains",
  components: { StringArray },
  props: {
    attribute: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<string[]>,
      required: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      allowAllDomains: this.items.includes("*"),
    }
  },
});
</script>
